<template>
  <v-card class="elevation-12">
    <v-toolbar dark v-bind:color="color">
      <v-toolbar-title>Login</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-tooltip bottom>
        <v-btn icon large target="_blank" slot="activator">
          <v-icon large>{{ icon }}</v-icon>
        </v-btn>
      </v-tooltip> -->
    </v-toolbar>

    <v-card-text>
      <div class="text-xs-center">
        <div class="text-xs-center" v-if="load">
          <v-progress-circular
            :indeterminate="load"
            color="primary"
          ></v-progress-circular>
        </div>

        <!-- Logo section with skeleton loading state -->
        <div
          style="
            display: flex;
            height: 100px;
            align-items: center;
            justify-content: center;
            margin-bottom: 16px;
          "
        >
          <!-- Skeleton loader para logo - só mostrar por tempo limitado -->
          <div v-if="isSystemLoading && showSkeleton" class="logo-skeleton">
            <v-layout row justify-center>
              <v-flex xs12 class="text-xs-center">
                <!-- Skeleton para logo usando padrão Vuetify 1.x -->
                <div class="skeleton-box logo-skeleton-box"></div>
                <!-- Pequeno skeleton para texto do app name -->
                <div class="skeleton-box text-skeleton-box"></div>
              </v-flex>
            </v-layout>
          </div>
          
          <!-- Logo loaded - mostrar logo -->
          <img 
            v-else 
            v-bind:src="logoLink" 
            style="max-width: 200px; max-height: 100px; object-fit: contain;"
            @error="onImageError" 
          />
        </div>
        <div v-if="errorStatus">
          <v-alert :value="true" type="error">
            <p>Erro: Não autorizado</p>
            <p>Descrição: {{ errorMessage }}</p>
          </v-alert>
        </div>
        <div v-show="recovered">
          <v-alert :value="true" type="success">
            <p>Solicitação enviada para o email de cadastro com sucesso!</p>
          </v-alert>
        </div>
      </div>
      <v-form
        ref="form"
        v-show="loginForm"
        v-model="valid"
        lazy-validation
        v-on:submit.prevent="getCredencials"
      >
        <v-text-field
          v-on:click="clear_err"
          v-model="user.email"
          v-on:keyup.enter="getCredencials"
          prepend-icon="person"
          name="login"
          label="E-mail"
          type="text"
          :rules="loginRules"
          required
        >
        </v-text-field>

        <v-text-field
          v-on:click="clear_err"
          v-model="user.password"
          v-on:keyup.enter="getCredencials"
          prepend-icon="lock"
          name="password"
          label="Senha"
          id="password"
          type="password"
          :rules="passwordRules"
          required
        >
        </v-text-field>
      </v-form>

      <v-form
        ref="form"
        v-show="recoveryPass"
        v-model="valid"
        lazy-validation
        v-on:submit.prevent="getCredencials"
      >
        <v-text-field
          v-on:click="clear_err"
          v-model="user.email"
          v-on:keyup.enter="getCredencials"
          prepend-icon="person"
          name="login"
          label="E-mail cadastrado"
          type="text"
          :rules="loginRules"
          required
        >
        </v-text-field>
      </v-form>

      <v-form
        ref="form"
        v-show="codeForm"
        v-model="valid"
        lazy-validation
        v-on:submit.prevent="validateCode"
      >
        <v-text-field
          v-on:click="clear_err"
          v-model="code"
          prepend-icon="lock"
          name="code"
          label="Código SMS"
          type="text"
          required
        >
        </v-text-field>
        <v-input
          hint="* Caso não receba o código, entre em contato com seu representante para atualizar seu cadastro."
        />
      </v-form>

      <v-checkbox
        v-show="showforgotPass"
        v-model="recoveryPass"
        v-on:change="changeForm"
        label="Esqueci minha senha"
      >
        ></v-checkbox
      >
    </v-card-text>
    <v-card-actions v-show="loginForm">
      <v-spacer></v-spacer>
      <v-btn
        class="white--text"
        v-bind:color="color"
        v-on:click="getCredencials"
        >Login</v-btn
      >
    </v-card-actions>
    <v-card-actions v-show="recoveryPass">
      <v-spacer></v-spacer>
      <v-btn class="white--text" v-bind:color="color" v-on:click="recovery"
        >Recuperar senha</v-btn
      >
    </v-card-actions>
    <v-card-actions v-show="codeForm">
      <v-spacer></v-spacer>
      <v-btn
        v-if="this.color === null || partner === 'establishment'"
        color="primary"
        v-on:click="validateCode"
        >Entrar</v-btn
      >
      <v-btn
        v-else
        v-bind:color="color"
        class="white--text"
        v-on:click="validateCode"
        >Entrar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LoginForm",
  data() {
    return {
      authenticated: false,
      unauthorized: false,
      recoveryPass: false,
      recovered: false,
      loginForm: true,
      codeForm: false,
      showforgotPass: true,
      code: "",
      message: "",
      icon: "code",
      user: {
        name: "",
        email: "",
        password: "",
      },
      valid: false,
      loginRules: [
        v => !!v || "E-mail é requerido",
        v => /.+@.+/.test(v) || "E-mail precisa ser válido",
      ],
      password: "",
      passwordRules: [v => !!v || "Senha é requirido"],
      showSkeleton: true, // Controlar exibição do skeleton
      skeletonTimeout: null, // Para timeout do skeleton
    };
  },
  computed: {
    ...mapGetters({
      id: "login/id",
      client_ref: "login/client_ref",
      load: "login/load",
      twofa: "login/twofa",
      token: "login/token",
      color: "login/color",
      logoLinkFromStore: "login/logoLink",
      systemLogoUrl: "system/logoUrl",
      systemConfiguration: "system/systemConfiguration",
      isSystemLoading: "system/isLoading",
      stylized: "login/stylized",
      partner: "login/partner",
      errorStatus: "login/errorStatus",
      successStatus: "login/successStatus",
      errorMessage: "login/errorMessage",
      getCredencialsResponse: "login/getCredencialsResponse",
      systemAppName: "system/appName",
    }),
    logoLink() {
      // Só retornar logo se não estiver carregando configuração do sistema
      if (this.isSystemLoading) {
        return '';
      }
      
      // Priorizar logo da configuração do sistema (reativo às mudanças)
      if (this.systemConfiguration && this.systemConfiguration.logo_url && 
          this.systemConfiguration.logo_url.trim() !== '') {
        return this.systemConfiguration.logo_url;
      }
      
      // Fallback para logo do login store se disponível (sistema antigo de parceiros)
      if (this.logoLinkFromStore && this.logoLinkFromStore.trim() !== '') {
        return this.logoLinkFromStore;
      }
      
      // Último fallback para logo padrão dos assets
      return require("@/assets/logo_flowit.png");
    },
  },
  watch: {
    successStatus() {
      this.$flowit.token.set(this.token);
      if (this.token === "") {
        // console.log("Disabled");
        this.$router.push("/login");
      } else {
        // console.log("Enabled");
        this.$router.push("/");
      }
    },
    twofa() {
      this.loginForm = false;
      this.recoveryPass = false;
      this.showforgotPass = false;
      this.codeForm = true;
    },
    token() {
      this.$flowit.token.set(this.token);
    },
    // Esconder skeleton quando o sistema parar de carregar
    isSystemLoading(newValue) {
      if (!newValue) {
        this.showSkeleton = false;
        // Limpar timeout pois não é mais necessário
        if (this.skeletonTimeout) {
          clearTimeout(this.skeletonTimeout);
          this.skeletonTimeout = null;
        }
      }
    },
    // Removido watchers problemáticos que tentavam modificar computed properties
    // stylized, color e logoLink são computed properties e não devem ser modificadas
  },
  /* Tratar aqui erro */
  created() {
    // Log para debugging do domínio atual
    console.log('=== DOMAIN DEBUG INFO ===');
    console.log('Current Domain:', window.location.hostname);
    console.log('Current Origin:', window.location.origin);
    console.log('Current URL:', window.location.href);
    console.log('Current Protocol:', window.location.protocol);
    console.log('Current Port:', window.location.port);
    console.log('=========================');
    
    // Carregar configuração do sistema para logos e cores
    this.$store.dispatch("system/fetchSystemConfiguration");
    
    // Timeout para esconder skeleton após 5 segundos, mesmo se não carregar
    this.skeletonTimeout = setTimeout(() => {
      this.showSkeleton = false;
    }, 5000);
    
    if (
      window.location.hostname !== `${this.systemAppName || process.env.VUE_APP_APP_NAME || "flowit"}.net` &&
      this.stylized === false
    ) {
      // console.log("hostname: ", window.location.hostname)
      this.$store.dispatch("login/getStyles", {
        url: window.location.hostname,
      });
    }
  },
  beforeDestroy() {
    // Limpar timeout se o componente for destruído
    if (this.skeletonTimeout) {
      clearTimeout(this.skeletonTimeout);
    }
  },
  methods: {
    getCredencials() {
      if (this.$refs.form.validate()) {
        this.params = {
          user: {
            email: this.user.email,
            password: this.user.password,
          },
        };
        this.$store.dispatch("login/getCredencials", this.params);
      }
    },
    validateCode() {
      if (this.$refs.form.validate()) {
        this.params = {
          code_validate: {
            sms_code: this.code,
            client_ref: this.client_ref,
            id: this.id,
          },
        };
        this.$store.dispatch("login/validateCode", this.params);
      }
    },
    recovery() {
      if (this.$refs.form.validate()) {
        this.$flowit
          .recovery(this.user.email)
          .then(() => {
            // console.log(`response: ${response.data}`);
            this.unauthorized = false;
            this.recovered = true;
          })
          .catch((responseError) => {
            // console.log(`error: ${responseError.response.data.error}`);
            this.$store.dispatch("login/errorStatus", true);
            this.$store.dispatch("login/errorMessage", responseError.response.data.error);
            this.unauthorized = true;
            this.recovered = false;
          });
      }
    },
    clear_err() {
      this.unauthorized = false;
    },
    changeForm() {
      if (this.loginForm === true) {
        this.loginForm = false;
        this.unauthorized = false;
      } else {
        this.loginForm = true;
        this.recovered = false;
      }
    },
    onImageError() {
      // Se a imagem falhar, garantir que o skeleton seja escondido
      this.showSkeleton = false;
      if (this.skeletonTimeout) {
        clearTimeout(this.skeletonTimeout);
        this.skeletonTimeout = null;
      }
    },
  },
};
</script>

<style scoped>
/* Skeleton loader styles baseado no padrão Vuetify 1.x */
.skeleton-box {
  background: linear-gradient(90deg, #f0f0f0 25%, rgba(255, 255, 255, 0.5) 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
}

.logo-skeleton-box {
  width: 160px;
  height: 80px;
  margin: 0 auto 12px auto;
}

.text-skeleton-box {
  width: 100px;
  height: 16px;
  margin: 0 auto;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Dark mode skeleton */
.theme--dark .skeleton-box {
  background: linear-gradient(90deg, #2a2a2a 25%, rgba(255, 255, 255, 0.1) 50%, #2a2a2a 75%);
  background-size: 200% 100%;
}
</style>
